import { createFlagsSchema, schema } from '@funtech-int/yango-shared';

export const featureFlagsSchema = createFlagsSchema({
    isNewPlayerEnabled: schema.boolean.optional(false),
});
